import store from '../store/index'
import router from '../router/router'

function extractErrorMessage(err, tag) {
  const detail = err?.response?.data?.detail

  if (detail) {
    return detail
  }

  if (err?.errorMsg) {
    return err.errorMsg
  }

  return err + ' @ tag ' + tag
}

function shouldForceLogout(err) {
  const status = err?.response?.status
  const url = String(err?.config?.url || '')

  if (status === 401) {
    return true
  }

  if (status === 403 && url.includes('/api/v1/dj-rest-auth/user/')) {
    return true
  }

  return false
}
//--------------
// handle error
//--------------
export default function handleError(err, tag) {
  console.log('ERROR!!!! = ' + err)
  console.log('@ tag ' + tag)
  // alert("error: " + err);
  //--------------
  // access store
  //--------------
  const this_store = store
  const this_router = router
  //-------------------
  // persist message
  //-------------------
  this_store.commit('auth/setMessage', extractErrorMessage(err, tag))

  if (!shouldForceLogout(err)) {
    return
  }

  //-------------------
  // clean-up & logoff
  //-------------------
  this_store.commit('auth/destroyToken')
  this_store.commit('auth/destroyUserProfile')
  this_router.push({ name: 'logoutView' })
}
